import React from 'react'
import MissionImg from "../images/principles/tuwe-mission-copy.png"
import VisionImg from "../images/principles/tuwe-vision-copy.png"
import ValueImg from "../images/principles/tuwe-values3-copy.png"
import { useEffect } from 'react'
import { useRef } from 'react'

const ServicesSection = () => {

     const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  return (
    <>
    {/* Services Section */}
<section id="services" className="services section" ref={servicesRef}>
  {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2 data-reveal>Our Core Pillars</h2>
    <p data-reveal>
      Principles That Shape Us
      <br />
    </p>
  </div>
  {/* End Section Title */}

  <div className="container" data-aos="fade-up" data-aos-delay="100">
    <div className="row gy-5">
      <div
        className="col-xl-4 col-md-6"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <div className="service-item">
          <div className="img" data-reveal>
            <img
              src={MissionImg}
              className="img-fluid"
              alt=""
            />
          </div>
          <div className="details position-relative" data-reveal>
            <div className="icon">
              <i className="bi bi-activity"></i>
            </div>
            <h3>Mission</h3>

            <p>
          To break the barriers of exclusion for young women and provide a pathway for agency
through an accessible digital pathway.
            </p>
          </div>
        </div>
      </div>
      {/* End Service Item */}

      <div
        className="col-xl-4 col-md-6"
        data-aos="zoom-in"
        data-aos-delay="300"
      >
        <div className="service-item">
          <div className="img" data-reveal>
            <img
              src={VisionImg}
              className="img-fluid"
              alt=""
            />
          </div>
          <div className="details position-relative" data-reveal>
            <div className="icon">
              <i className="bi bi-broadcast"></i>
            </div>
            <h3>Vision</h3>

            <p>
           A future where systemic poverty no longer determines young women’s agency.
            </p>
          </div>
        </div>
      </div>
      {/* End Service Item */}

      <div
        className="col-xl-4 col-md-6"
        data-aos="zoom-in"
        data-aos-delay="400"
      >
        <div className="service-item">
          <div className="img" data-reveal>
            <img
              src= {ValueImg}
              className="img-fluid"
              alt=""
            />
          </div>
          <div className="details position-relative" data-reveal>
            <div className="icon">
              <i className="bi bi-easel"></i>
            </div>
            <h3>Values</h3>

            <p>
              Through Tuwe Initiative, we aim to create a world where
              resilience meets opportunity, unlocking the potential of
              every individual to rise above adversity and contribute to a
              thriving, equitable society.
              <br />
              <br />
              <a href="/values" className="value_btn" type="submit">
                Our Values
              </a>
            </p>
          </div>
        </div>
      </div>
      {/* End Service Item */}
    </div>
  </div>
</section>
{/* /Services Section */}

    </>
  )
}

export default ServicesSection